import {type Line} from '../../../util/plotHelpers/types';
import {getProfiledAlignedData} from './getAlignedData';
import {getSeriesEntries} from './getSeriesEntries';

/** Own one alignment per panel revision; chart instances only read these arrays. */
export function prepareUPlotData(lines: Line[], xLogScale?: boolean) {
  const entries = getSeriesEntries(lines);
  return {
    ...entries,
    ...getProfiledAlignedData(entries.seriesEntries, xLogScale),
  };
}

export type PreparedUPlotData = ReturnType<typeof prepareUPlotData>;
